"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9927],{

/***/ 15396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ko": function() { return /* binding */ formatDateToShort; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export toCamelCase */
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99490);
/* harmony import */ var _sonar_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34437);


/**
 * Converts a string from hyphen-separated or snake_case to camelCase
 */ const toCamelCase = (string)=>string.replace(/[-|_](\w)/g, (str)=>str[1].toUpperCase());
/**
 * Converts a luxon datetime object to short format
 * see https://moment.github.io/luxon/docs/manual/formatting.html#toformat
 */ const formatDateToShort = (date)=>date.toLocaleString({
        month: "short",
        day: "numeric"
    });
const firstWeekLetter = _sonar_i18n__WEBPACK_IMPORTED_MODULE_0__/* ["default"].t */ .Z.t("period.aggregate.week").charAt(0);
/**
 * Format date according to data value
 */ const formatDate = (dateToFormat, aggregate, locale)=>{
    const dateTime = typeof dateToFormat === "string" ? luxon__WEBPACK_IMPORTED_MODULE_1__/* .DateTime.fromISO */ .ou.fromISO(dateToFormat) : dateToFormat instanceof Date ? luxon__WEBPACK_IMPORTED_MODULE_1__/* .DateTime.fromJSDate */ .ou.fromJSDate(dateToFormat) : dateToFormat;
    const localeDateTime = dateTime.setLocale(locale);
    const dateFormatted = {
        hour: (date)=>date.toLocaleString({
                hour: "numeric"
            }),
        day: (date)=>date.toLocaleString({
                month: "numeric",
                day: "numeric"
            }),
        week: (date)=>date.toFormat("WW '".concat(firstWeekLetter, "'")),
        month: (date)=>date.toLocaleString({
                month: "short"
            }),
        sevenDays: (date)=>date.toLocaleString({
                month: "numeric",
                day: "numeric"
            }),
        default: (date)=>date.toLocaleString({
                month: "numeric",
                day: "numeric"
            })
    };
    return dateFormatted[aggregate](localeDateTime) || dateFormatted.default(localeDateTime);
};


/***/ }),

/***/ 39771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kk": function() { return /* binding */ areAverageSpentsLoading; },
/* harmony export */   "uv": function() { return /* binding */ getAverageSpentsChartData; },
/* harmony export */   "zn": function() { return /* binding */ getAverageSpentsError; }
/* harmony export */ });
/* unused harmony exports getSelectedAverageSpentsChart, getAverageSpentsChartTaxExcluded, getAverageSpentsChartTaxIncluded */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95861);
/* harmony import */ var _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73044);
/* harmony import */ var _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95321);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37338);
/* harmony import */ var _Revenues_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14164);


/**
 * Average expense memoized selectors
 * All data are computed from customers counts and revenues fetched data
 */ 





/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getAverageSpentsError = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getCustomersCountsError */ .Y9,
    _Revenues_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getRevenuesError */ .HI
], (customersCountsError, revenuesError)=>customersCountsError || revenuesError);
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areAverageSpentsLoading = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__/* .areCustomersCountsLoading */ .AP,
    _Revenues_selectors__WEBPACK_IMPORTED_MODULE_4__/* .areRevenuesLoading */ .dL
], (customersCountsLoading, revenuesLoading)=>customersCountsLoading || revenuesLoading);
/**
 * Compute average expense based on revenues and customers counts data
 *
 * @return {Object}
 */ const getSelectedAverageSpentsChart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSelectedCustomersCountsChart */ .C5,
    _Revenues_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getSelectedRevenuesChart */ .Ed
], (customersCounts, revenues)=>{
    if (!customersCounts || !revenues) {
        return null;
    }
    return Object.keys(customersCounts).reduce((averageSpents, storeId)=>{
        const currentCustomersCounts = customersCounts[storeId];
        const selected = currentCustomersCounts.selected ? Object.keys(currentCustomersCounts.selected.values).reduce((selected, value)=>{
            const customersCounts = currentCustomersCounts.selected.values[value].value.customersCount;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, selected), {
                [value]: {
                    value: {
                        tax_excluded: customersCounts ? revenues[storeId].selected.values[value].value.tax_excluded / customersCounts : 0,
                        tax_included: customersCounts ? revenues[storeId].selected.values[value].value.tax_included / customersCounts : 0
                    }
                }
            });
        }, {}) : null;
        const reference = currentCustomersCounts.reference ? Object.keys(currentCustomersCounts.reference.values).reduce((reference, value)=>{
            const { customersCount  } = currentCustomersCounts.reference.values[value].value;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, reference), {
                [value]: {
                    value: {
                        tax_excluded: customersCount ? revenues[storeId].reference.values[value].value.tax_excluded / customersCount : 0,
                        tax_included: customersCount ? revenues[storeId].reference.values[value].value.tax_included / customersCount : 0
                    }
                }
            });
        }, {}) : null;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, averageSpents), {
            [storeId]: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, selected ? {
                selected: {
                    values: selected
                }
            } : {}, reference ? {
                reference: {
                    values: reference
                }
            } : {})
        });
    }, {});
});
/**
 * Get average expense data chart without tax
 * Calculates average spent without tax for bar chart on selected stores
 *
 * @return {Array}
 */ const getAverageSpentsChartTaxExcluded = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedPeriod */ .Wp,
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedTimeAggregate */ .TV,
    getSelectedAverageSpentsChart,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectCurrency */ .j,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectStores */ .EJ,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectColorMapping */ .VC,
    _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSelectedCustomersCountsChart */ .C5, 
], (period, aggregate, averageSpents, currency, stores, colorMapping, customersCounts)=>averageSpents && customersCounts ? (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .createChartData */ .jl)({
        data: averageSpents,
        interval: period.interval,
        kpi: "average-spent",
        tax: "tax_excluded",
        aggregate,
        colorMapping,
        currency,
        customersCounts,
        stores
    }) : []);
/**
 * Get average expense data chart with tax
 * Calculates average expense with tax for bar chart on selected stores
 *
 * @return {Array}
 */ const getAverageSpentsChartTaxIncluded = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedPeriod */ .Wp,
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedTimeAggregate */ .TV,
    getSelectedAverageSpentsChart,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectCurrency */ .j,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectStores */ .EJ,
    _Stores_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectColorMapping */ .VC,
    _CustomersCounts_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSelectedCustomersCountsChart */ .C5, 
], (period, aggregate, averageSpents, currency, stores, colorMapping, customersCounts)=>averageSpents && customersCounts ? (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .createChartData */ .jl)({
        data: averageSpents,
        interval: period.interval,
        tax: "tax_included",
        aggregate,
        colorMapping,
        currency,
        customersCounts,
        stores
    }) : []);
/**
 * Calculates average expense for bar chart on selected stores
 *
 * @return {Array}
 */ const getAverageSpentsChartData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_0__/* .selectIsTaxIncluded */ .t3,
    getAverageSpentsChartTaxIncluded,
    getAverageSpentsChartTaxExcluded
], (isTaxIncluded, averageSpentsTaxIncluded, averageSpentsTaxExcluded)=>isTaxIncluded ? averageSpentsTaxIncluded : averageSpentsTaxExcluded);


/***/ }),

/***/ 95321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ areCustomersCountsLoading; },
/* harmony export */   "C5": function() { return /* binding */ getSelectedCustomersCountsChart; },
/* harmony export */   "Y9": function() { return /* binding */ getCustomersCountsError; },
/* harmony export */   "e_": function() { return /* binding */ getCustomersCountsChartData; }
/* harmony export */ });
/* unused harmony exports getCustomersCountsEntities, getCustomersCountsStatus */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _Preferences__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46445);
/* harmony import */ var _Stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74919);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37338);

/**
 * CustomersCounts memoized Selectors
 *
 */ 



/**
 * Get data about customers counts retrieved from api
 *
 * @return {Object}
 */ const getCustomersCountsEntities = (param)=>{
    let { entities  } = param;
    return entities.customersCounts.entities;
};
/**
 * Get status about customers counts request
 * `none`, `loading`, `loaded` or `failed`
 *
 * @return {string}
 */ const getCustomersCountsStatus = (param)=>{
    let { entities  } = param;
    return entities.customersCounts.status;
};
/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getCustomersCountsError = (param)=>{
    let { entities  } = param;
    return entities.customersCounts.error;
};
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areCustomersCountsLoading = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    getCustomersCountsStatus
], (status)=>status === "loading");
/**
 *
 * Get customers counts data of selected stores
 *
 * @return {Object}
 */ const getSelectedCustomersCountsChart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    getCustomersCountsEntities,
    _Preferences__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedStoresIds */ .F
], (customersCountsEntities, selectedStoreIds)=>{
    if (!customersCountsEntities) {
        return null;
    }
    const customersCounts = Object.keys(customersCountsEntities).reduce((dataOfSelectedStores, storeId)=>selectedStoreIds.includes(parseInt(storeId, 10)) ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dataOfSelectedStores, customersCountsEntities[storeId] ? {
            [storeId]: customersCountsEntities[storeId]
        } : {}) : dataOfSelectedStores, {});
    if (!Object.keys(customersCounts).length) {
        return null;
    }
    return customersCounts;
});
/**
 * Calculates customers counts for bar chart on selected stores
 *
 * @return {Array}
 */ const getCustomersCountsChartData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _Preferences__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedPeriod */ .Wp,
    _Preferences__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedTimeAggregate */ .TV,
    getSelectedCustomersCountsChart,
    _Stores__WEBPACK_IMPORTED_MODULE_1__/* .selectStores */ .EJ,
    _Stores__WEBPACK_IMPORTED_MODULE_1__/* .selectColorMapping */ .VC, 
], (period, aggregate, customersCounts, stores, colorMapping)=>customersCounts ? (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .createChartData */ .jl)({
        interval: period.interval,
        data: customersCounts,
        aggregate,
        colorMapping,
        stores
    }) : []);


/***/ }),

/***/ 6279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RG": function() { return /* binding */ CUSTOMERS_COUNTS_AGGREGATED_FAILED; },
/* harmony export */   "bQ": function() { return /* binding */ CUSTOMERS_COUNTS_AGGREGATED_REQUESTED; },
/* harmony export */   "sE": function() { return /* binding */ CUSTOMERS_COUNTS_AGGREGATED_SUCCEEDED; }
/* harmony export */ });
/**
 * CustomersCounts action types
 */ const CUSTOMERS_COUNTS_AGGREGATED_FAILED = "[CUSTOMERS_COUNTS AGGREGATED] FAILED";
const CUSTOMERS_COUNTS_AGGREGATED_REQUESTED = "[CUSTOMERS_COUNTS AGGREGATED] REQUESTED";
const CUSTOMERS_COUNTS_AGGREGATED_SUCCEEDED = "[CUSTOMERS_COUNTS AGGREGATED] SUCCEEDED";


/***/ }),

/***/ 87652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sk": function() { return /* binding */ customersCountsAggregatedSucceeded; },
/* harmony export */   "c2": function() { return /* binding */ customersCountsAggregatedFailed; },
/* harmony export */   "q9": function() { return /* binding */ customersCountsAggregatedRequested; }
/* harmony export */ });
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6279);
/**
 * Aggregated customers counts actions
 */ 
/**
 * Request for aggregated customers counts failed
 *
 * @param {Object} error
 *
 * @return {Object}
 */ const customersCountsAggregatedFailed = (error)=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMERS_COUNTS_AGGREGATED_FAILED */ .RG,
        payload: error
    });
/**
 * Trigger a request for aggregated customers counts data
 *
 * @return {Object}
 */ const customersCountsAggregatedRequested = ()=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMERS_COUNTS_AGGREGATED_REQUESTED */ .bQ
    });
/**
 * Request for aggregated customers counts has been successful
 *
 * @param {Array} data
 *
 * @return {Object}
 */ const customersCountsAggregatedSucceeded = (data)=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMERS_COUNTS_AGGREGATED_SUCCEEDED */ .sE,
        payload: data
    });


/***/ }),

/***/ 14164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ getSelectedRevenuesChart; },
/* harmony export */   "En": function() { return /* binding */ getRevenuesChartData; },
/* harmony export */   "HI": function() { return /* binding */ getRevenuesError; },
/* harmony export */   "dL": function() { return /* binding */ areRevenuesLoading; }
/* harmony export */ });
/* unused harmony exports getRevenuesEntities, getRevenuesStatus, getRevenuesChartTaxExcluded, getRevenuesChartTaxIncluded */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74919);
/* harmony import */ var _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95861);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37338);

/**
 * Revenues memoized selectors
 */ 



/**
 * Get data about revenues retrieved from api
 *
 * @return {Object}
 */ const getRevenuesEntities = (param)=>{
    let { entities  } = param;
    return entities.revenues.entities;
};
/**
 * Get status about revenues request
 * `none`, `loading`, `loaded` or `failed`
 *
 * @return {string}
 */ const getRevenuesStatus = (param)=>{
    let { entities  } = param;
    return entities.revenues.status;
};
/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getRevenuesError = (param)=>{
    let { entities  } = param;
    return entities.revenues.error;
};
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areRevenuesLoading = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    getRevenuesStatus
], (status)=>status === "loading");
/**
 *
 * Get revenues data of selected stores
 *
 * @return {Object}
 */ const getSelectedRevenuesChart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    getRevenuesEntities,
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSelectedStoresIds */ .F
], (revenuesEntities, selectedStoreIds)=>{
    if (!revenuesEntities || !selectedStoreIds || !selectedStoreIds.length) {
        return null;
    }
    const revenues = Object.keys(revenuesEntities).reduce((dataOfSelectedStores, storeId)=>selectedStoreIds.includes(parseInt(storeId, 10)) ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dataOfSelectedStores, revenuesEntities[storeId] ? {
            [storeId]: revenuesEntities[storeId]
        } : {}) : dataOfSelectedStores, {});
    if (!Object.keys(revenues).length) {
        return null;
    }
    return revenues;
});
/**
 * Get revenues data chart without tax
 * Calculates revenues without tax for bar chart on selected stores
 *
 * @return {Array}
 */ const getRevenuesChartTaxExcluded = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSelectedPeriod */ .Wp,
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSelectedTimeAggregate */ .TV,
    getSelectedRevenuesChart,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectCurrency */ .j,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectStores */ .EJ,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectColorMapping */ .VC, 
], (period, aggregate, revenues, currency, stores, colorMapping)=>revenues ? (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .createChartData */ .jl)({
        data: revenues,
        interval: period.interval,
        tax: "tax_excluded",
        aggregate,
        colorMapping,
        currency,
        stores
    }) : []);
/**
 * Get revenues data chart with tax
 * Calculates revenues with tax for bar chart on selected stores
 *
 * @return {Array}
 */ const getRevenuesChartTaxIncluded = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSelectedPeriod */ .Wp,
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSelectedTimeAggregate */ .TV,
    getSelectedRevenuesChart,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectCurrency */ .j,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectStores */ .EJ,
    _sonar_modules_Stores__WEBPACK_IMPORTED_MODULE_0__/* .selectColorMapping */ .VC, 
], (period, aggregate, revenues, currency, stores, colorMapping)=>revenues ? (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .createChartData */ .jl)({
        data: revenues,
        interval: period.interval,
        tax: "tax_included",
        aggregate,
        colorMapping,
        currency,
        stores
    }) : []);
/**
 * Calculates revenues for bar chart on selected stores
 *
 * @return {Array}
 */ const getRevenuesChartData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _Preferences_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectIsTaxIncluded */ .t3,
    getRevenuesChartTaxIncluded,
    getRevenuesChartTaxExcluded
], (isTaxIncluded, revenuesTaxIncluded, revenuesTaxExcluded)=>isTaxIncluded ? revenuesTaxIncluded : revenuesTaxExcluded);


/***/ }),

/***/ 76353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": function() { return /* binding */ REVENUES_AGGREGATED_FAILED; },
/* harmony export */   "F7": function() { return /* binding */ REVENUES_AGGREGATED_SUCCEEDED; },
/* harmony export */   "uw": function() { return /* binding */ REVENUES_AGGREGATED_REQUESTED; }
/* harmony export */ });
/**
 * Aggregated revenues action types
 */ const REVENUES_AGGREGATED_FAILED = "[REVENUES AGGREGATED] FAILED";
const REVENUES_AGGREGATED_REQUESTED = "[REVENUES AGGREGATED] REQUESTED";
const REVENUES_AGGREGATED_SUCCEEDED = "[REVENUES AGGREGATED] SUCCEEDED";


/***/ }),

/***/ 68174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I$": function() { return /* binding */ revenuesAggregatedFailed; },
/* harmony export */   "gG": function() { return /* binding */ revenuesAggregatedRequested; },
/* harmony export */   "vt": function() { return /* binding */ revenuesAggregatedSucceeded; }
/* harmony export */ });
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76353);
/**
 * Aggregated revenues actions
 */ 
/**
 * Request for aggregated revenues failed
 *
 * @param {Object} error
 *
 * @return {Object}
 */ const revenuesAggregatedFailed = (error)=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .REVENUES_AGGREGATED_FAILED */ .$v,
        payload: error
    });
/**
 * Trigger a request for aggregated revenues data
 *
 * @return {Object}
 */ const revenuesAggregatedRequested = ()=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .REVENUES_AGGREGATED_REQUESTED */ .uw
    });
/**
 * Request for aggregated revenues has been successful
 *
 * @param {Array} data
 *
 * @return {Object}
 */ const revenuesAggregatedSucceeded = (data)=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .REVENUES_AGGREGATED_SUCCEEDED */ .F7,
        payload: data
    });


/***/ }),

/***/ 56511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cQ": function() { return /* binding */ EXPORT_SYNTHESIS_REQUESTED; },
/* harmony export */   "fD": function() { return /* binding */ EXPORT_SALES_REQUESTED; },
/* harmony export */   "t_": function() { return /* binding */ CHART_REQUESTED; }
/* harmony export */ });
/**
 * Entities action types
 */ const CHART_REQUESTED = "[REPORTS] CHART REQUESTED";
const EXPORT_SYNTHESIS_REQUESTED = "[REPORTS] EXPORT SYNTHESIS REQUESTED";
const EXPORT_SALES_REQUESTED = "[REPORTS] EXPORT SALES REQUESTED";


/***/ }),

/***/ 5135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y_": function() { return /* binding */ reportSynthesisRequested; },
/* harmony export */   "iz": function() { return /* binding */ chartRequested; },
/* harmony export */   "pW": function() { return /* binding */ salesReportRequested; }
/* harmony export */ });
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56511);
/**
 * Entities actions
 */ 
/**
 * Chart data requested triggered for dashboard page
 *
 * @return {Object}
 */ const chartRequested = (payload)=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CHART_REQUESTED */ .t_,
        payload
    });
/**
 * Report synthesis requested
 * dispatch this action to request a dashboard export
 *
 * @return {Object}
 */ const reportSynthesisRequested = ()=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .EXPORT_SYNTHESIS_REQUESTED */ .cQ
    });
/**
 * Sales report requested
 * dispatch this action to request a sales report export
 *
 * @return {Object}
 */ const salesReportRequested = ()=>({
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .EXPORT_SALES_REQUESTED */ .fD
    });






/***/ }),

/***/ 37338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ae": function() { return /* binding */ getSalesDataOfSelectedStores; },
/* harmony export */   "I": function() { return /* binding */ createProductTypeChart; },
/* harmony export */   "fn": function() { return /* binding */ getEvolution; },
/* harmony export */   "iz": function() { return /* binding */ setAdjustedPeriod; },
/* harmony export */   "jl": function() { return /* binding */ createChartData; }
/* harmony export */ });
/* unused harmony exports getAggregatedDataLabel, getPeriodLabel, getEndDatesFromCurrentTills */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99490);
/* harmony import */ var _sonar_components_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36737);
/* harmony import */ var _sonar_helpers_formatting__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15396);
/* harmony import */ var _sonar_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34437);







/**
 * Legend displayed on the Dashboard chart for aggregated data.
 *
 * @param {Interval} interval - Luxon interval. The displayed legend is the selected period by the user
 *
 * @return {string}
 */ const getAggregatedDataLabel = (interval)=>_sonar_i18n__WEBPACK_IMPORTED_MODULE_3__/* ["default"].t */ .Z.t("dashboard.kpi_chart.legend", {
        start: (0,_sonar_helpers_formatting__WEBPACK_IMPORTED_MODULE_2__/* .formatDateToShort */ .ko)(interval.s),
        end: (0,_sonar_helpers_formatting__WEBPACK_IMPORTED_MODULE_2__/* .formatDateToShort */ .ko)(interval.e)
    });
/**
 * Helper function that return the formatted period selected by the user
 *
 * @param {string} aggregate - 'hour', 'day, 'week',...
 * @param {Interval} interval - selected period
 *
 * @return {string}
 */ const getPeriodLabel = (aggregate, interval)=>aggregate === "hour" ? (0,_sonar_helpers_formatting__WEBPACK_IMPORTED_MODULE_2__/* .formatDateToShort */ .ko)(interval.s) : getAggregatedDataLabel(interval);
/**
 * Helper function that structures the input data for a chart of the Dashboard page
 * See https://vx-demo.now.sh/barstack
 *
 * @param {string} aggregate - 'hour', 'day, 'week',...
 * @param {Object} colorMapping - mapping between colors and data category (store or period)
 * @param {string} [currency] - currency code received by api
 * @param {[]|undefined} customersCounts - if present, data is for average spent. Needed to compute the weighted average for total
 * @param {Object} data - data of the selected period
 * @param {Interval} interval - selected period
 * @param {[]} [stores] - information about stores and which are selected
 * @param {string} [tax] - `tax_excluded` or `tax_included`
 *
 * @return {[]}
 */ const createChartData = (param)=>{
    let { aggregate , colorMapping , currency , customersCounts , data , interval , stores =[] , tax ,  } = param;
    if (!Object.keys(data)) {
        return [];
    }
    const periodLabel = getPeriodLabel(aggregate, interval);
    const dataPerStore = Object.entries(data);
    const chartData = dataPerStore.reduce((result, param, storeIndex)=>{
        let [storeId, { selected , reference  }] = param;
        const selectedValuesPerDate = selected ? Object.entries(selected.values).sort() : [];
        const referenceValuesPerDate = reference ? Object.entries(reference.values).sort() : null;
        const selectedValuesOfSingleStore = selectedValuesPerDate.reduce((agg, param, i)=>{
            let [date, { value  }] = param;
            const store = stores.find((param)=>{
                let { id  } = param;
                return id === parseInt(storeId, 10);
            });
            if (!store) {
                return agg;
            }
            const storeName = store.name;
            const selectedValue = tax ? value[tax] : value.customersCount;
            const referenceValue = referenceValuesPerDate ? tax ? referenceValuesPerDate[i][1].value[tax] : referenceValuesPerDate[i][1].value.customersCount : 0;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, agg), {
                [date]: {
                    [storeName]: selectedValue,
                    ["".concat(storeName, "Evolution")]: getEvolution(selectedValue, referenceValue),
                    ["".concat(storeName, "Color")]: colorMapping[storeName],
                    [periodLabel]: selectedValue,
                    reference: referenceValuesPerDate ? tax ? referenceValuesPerDate[i][1].value[tax] : referenceValuesPerDate[i][1].value.customersCount : 0
                }
            });
        }, {});
        const selectedEntries = Object.entries(selectedValuesOfSingleStore);
        return selectedEntries.reduce((agg, param, i)=>{
            let [date, content] = param;
            let selectedTotal;
            let referenceTotal;
            if (customersCounts) {
                // for average spent of all stores,the sum of all stores is not the sum of average spent
                // so we weight by the number of customers
                selectedTotal = (result[date] ? result[date][periodLabel] : 0) + content[periodLabel] * customersCounts[storeId].selected.values[date].value.customersCount;
                referenceTotal = (result[date] ? result[date].reference : 0) + content.reference * (customersCounts[storeId].reference ? Object.values(customersCounts[storeId].reference.values)[i].value.customersCount : 0);
            } else {
                selectedTotal = (result[date] ? result[date][periodLabel] : 0) + content[periodLabel];
                referenceTotal = (result[date] ? result[date].reference : 0) + content.reference;
            }
            const formattedData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, agg), {
                [date]: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, result[date], content), {
                    [periodLabel]: selectedTotal,
                    reference: referenceTotal,
                    evolution: getEvolution(selectedTotal, referenceTotal)
                }), !agg[date] && {
                    name: periodLabel,
                    ["".concat(periodLabel, "Color")]: _sonar_components_Theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].palette.chart.aggregated */ .C.palette.chart.aggregated,
                    currency,
                    aggregate,
                    from: date,
                    to: i < selectedEntries.length - 1 ? luxon__WEBPACK_IMPORTED_MODULE_6__/* .DateTime.fromISO */ .ou.fromISO(selectedEntries[i + 1][0]).minus(1).toISO() : interval.e.toISO()
                })
            });
            // compute evolution once we have accumulated entire values for selected and reference
            if (storeIndex === dataPerStore.length - 1) {
                if (customersCounts) {
                    const totalSelectedCustomers = Object.values(customersCounts).map((param)=>{
                        let { selected  } = param;
                        return selected;
                    }).reduce((acc, param)=>{
                        let { values  } = param;
                        return acc + values[date].value.customersCount;
                    }, 0) || 1;
                    const totalReferenceCustomers = Object.values(customersCounts).map((param)=>{
                        let { reference  } = param;
                        return reference;
                    }).reduce((acc, reference)=>acc + (reference ? Object.values(reference.values)[i].value.customersCount : 0), 0) || 1;
                    formattedData[date][periodLabel] /= totalSelectedCustomers;
                    formattedData[date].reference /= totalReferenceCustomers;
                }
                formattedData[date].evolution = getEvolution(formattedData[date][periodLabel], formattedData[date].reference);
            }
            return formattedData;
        }, {});
    }, {});
    return Object.values(chartData);
};
/**
 * Helper function that return the formatted period selected by the user
 * Types must be sorted by descending turnover
 *
 * @param {Object} data - turnover of stores by product type
 * @param {Array} colorMapping - association of each type to a color
 * @param {string} tax - `tax_excluded` or `tax_included`
 *
 * @return {import('@sonar/components/Charts/Widget/types').WidgetChartData[]}
 */ const createProductTypeChart = (data, colorMapping, tax)=>{
    if (!data) return [];
    let totalTurnover = 0;
    return Object.values(data).reduce((data, store)=>{
        var ref;
        const selectedTypes = ((ref = store.selected) === null || ref === void 0 ? void 0 : ref.values) || {};
        Object.entries(selectedTypes).forEach((param)=>{
            let [type, value] = param;
            const amount = value.value[tax];
            totalTurnover += amount;
            const existingIndex = data.findIndex((d)=>d.type === type);
            if (existingIndex >= 0) {
                data[existingIndex] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data[existingIndex]), {
                    amount: data[existingIndex].amount + amount
                });
            } else {
                var ref, ref1;
                const referenceTypes = (ref = store.reference) === null || ref === void 0 ? void 0 : ref.values;
                const referenceAmount = referenceTypes === null || referenceTypes === void 0 ? void 0 : (ref1 = referenceTypes[type]) === null || ref1 === void 0 ? void 0 : ref1.value[tax];
                data.push({
                    amount,
                    color: colorMapping[type],
                    evolution: getEvolution(amount, referenceAmount || 0),
                    type
                });
            }
        });
        return data;
    }, []).map((type)=>(0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, type), {
            amount: type.amount,
            percent: type.amount / totalTurnover
        })).sort((a, b)=>b.amount - a.amount);
};
/**
 * Get evolution between selected and reference values
 * Ratio between reference and selected
 *
 * @param {number} selected - actual value from which we want the evolution
 * @param {number} reference - reference value to which the selected value is compared to
 *
 * @return {number}
 */ const getEvolution = (selected, reference)=>reference > 0 ? parseFloat(((selected - reference) / reference).toFixed(4)) : selected > 0 ? 1 : 0;
/**
 *
 * @param {import('@sonar/modules/CurrentTills').ManyCurrentTillsInfo} tills
 * @param {import('@sonar/models').Period} period
 * @returns {import('@tiller/report-sdk').Limits}
 */ const getEndDatesFromCurrentTills = (tills, period)=>{
    return reduce(tills, (limitsAcc, param, storeId)=>{
        let { openDate  } = param;
        const tillOpenDate = openDate && DateTime.fromISO(openDate, {
            zone: "UTC"
        });
        const endDateLimit = tillOpenDate && tillOpenDate < period.interval.end ? tillOpenDate : period.interval.end;
        limitsAcc.push({
            storeId: Number(storeId),
            endDateLimit
        });
        return limitsAcc;
    }, []);
};
/**
 * Set selected period + 1 day if end timeslot is superior to start timeslot
 * return period set with start / end timeslots
 *
 * @param {number} start - start timeslot
 * @param {number} end - end timeslot
 * @param {Period} period - period created from given period interval
 *
 * @return {void}
 */ const setAdjustedPeriod = (start, end, period)=>{
    // end of period is the day after the ending date but displayed period stays as is
    if (start >= end) {
        period.plus({
            end: {
                days: 1
            }
        });
    }
    period.set({
        start: {
            hours: start
        },
        end: {
            hours: end,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        }
    });
};
const getSalesDataOfSelectedStores = (entities, stores, storeIds)=>{
    if (!Object.keys(entities).length || !stores.length || !storeIds.length) {
        return [];
    }
    return storeIds.map((storeId)=>{
        const { name  } = stores.find((param)=>{
            let { id  } = param;
            return id === storeId;
        });
        return {
            name,
            data: entities[storeId] || []
        };
    }).reduce((a, b)=>a.concat(b.data.map((product)=>(0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                store: b.name
            }, product))), []);
};


/***/ }),

/***/ 69927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iF": function() { return /* reexport */ OrderStatus; },
  "X_": function() { return /* reexport */ computeEvolution; },
  "wv": function() { return /* reexport */ getAggregateOrderValue; },
  "ab": function() { return /* reexport */ Orders_reducer; },
  "TR": function() { return /* reexport */ requestOrderInfo; },
  "en": function() { return /* reexport */ selectAreOrdersLoaded; },
  "MC": function() { return /* reexport */ selectClosedAndCanceledOrders; },
  "W2": function() { return /* reexport */ selectHasUnprocessableEntityError; },
  "P3": function() { return /* reexport */ selectOrdersError; },
  "d8": function() { return /* reexport */ useLegacyOrdersAggregated/* default */.Z; },
  "EV": function() { return /* reexport */ Orders_useLegacyOrdersExport; },
  "q4": function() { return /* reexport */ Orders_useLegacyOrdersKpi; },
  "_C": function() { return /* reexport */ Orders_useOrdersAggregated; },
  "gQ": function() { return /* reexport */ Orders_useOrdersKpi; },
  "Jo": function() { return /* reexport */ ordersWatcher; }
});

// UNUSED EXPORTS: ApiAggregatedOrdersField, ApiOrdersAggregate, ApiOrdersField, failedOrderInfo, selectAllOrders, succeededOrderInfo

;// CONCATENATED MODULE: ./src/modules/Orders/helpers.ts
/**
 * Initialise an aggregated order data with all value to 0
 * @returns an initialized aggregated order
 */ const initAggregatedOrder = ()=>({
        sumOrderAverageSpentTaxExcluded: 0,
        sumOrderAverageSpentTaxIncluded: 0,
        sumOrderCustomersCount: 0,
        sumOrderDiscountAmount: 0,
        sumOrderTotalCancelled: 0,
        sumOrderTotalDiscount: 0,
        sumOrderTotalTaxAmount: 0,
        sumOrderTotalTaxExcluded: 0,
        sumOrderTotalTaxIncluded: 0
    });
/**
 * Get the value of one of the aggregated order props or the default value if nothing is set
 *
 * @param aggregatedOrder the aggregated order to get a value from
 * @param propName the prop name to get the value
 * @param defaultValue the default value to use if the aggregated order is undefined of the prop not set
 * @returns the value if found, otherwise the default value, 0 by default
 */ const getAggregateOrderValue = function(aggregatedOrder, propName) {
    let defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return !aggregatedOrder ? defaultValue : Number(aggregatedOrder[propName]) || defaultValue;
};
const computeAverageSpent = (total, customersCounts)=>customersCounts > 0 ? total / customersCounts : total;
/**
 * Get evolution between selected and reference values
 * Ratio between reference and selected
 *
 * @param selected - actual value from which we want the evolution
 * @param reference - reference value to which the selected value is compared to
 */ const computeEvolution = (selected, reference)=>{
    if (reference > 0) {
        return parseFloat(((selected - reference) / reference).toFixed(4));
    }
    return selected > 0 ? 1 : 0;
};
/**
 * Sum 2 aggregated order
 *
 * @param aggregatedOrdersA first aggregated order to sum
 * @param aggregatedOrdersB second aggregated order to sum
 * @returns the summed aggregated order
 */ const sumAggregatedOrders = function() {
    let aggregatedOrdersA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initAggregatedOrder(), aggregatedOrdersB = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : initAggregatedOrder();
    return {
        sumOrderAverageSpentTaxExcluded: computeAverageSpent(aggregatedOrdersA.sumOrderTotalTaxExcluded + aggregatedOrdersB.sumOrderTotalTaxExcluded, aggregatedOrdersA.sumOrderCustomersCount + aggregatedOrdersB.sumOrderCustomersCount),
        sumOrderAverageSpentTaxIncluded: computeAverageSpent(aggregatedOrdersA.sumOrderTotalTaxIncluded + aggregatedOrdersB.sumOrderTotalTaxIncluded, aggregatedOrdersA.sumOrderCustomersCount + aggregatedOrdersB.sumOrderCustomersCount),
        sumOrderCustomersCount: aggregatedOrdersA.sumOrderCustomersCount + aggregatedOrdersB.sumOrderCustomersCount,
        sumOrderDiscountAmount: aggregatedOrdersA.sumOrderDiscountAmount + aggregatedOrdersB.sumOrderDiscountAmount,
        sumOrderTotalCancelled: aggregatedOrdersA.sumOrderTotalCancelled + aggregatedOrdersB.sumOrderTotalCancelled,
        sumOrderTotalDiscount: aggregatedOrdersA.sumOrderTotalDiscount + aggregatedOrdersB.sumOrderTotalDiscount,
        sumOrderTotalTaxAmount: aggregatedOrdersA.sumOrderTotalTaxAmount + aggregatedOrdersB.sumOrderTotalTaxAmount,
        sumOrderTotalTaxExcluded: aggregatedOrdersA.sumOrderTotalTaxExcluded + aggregatedOrdersB.sumOrderTotalTaxExcluded,
        sumOrderTotalTaxIncluded: aggregatedOrdersA.sumOrderTotalTaxIncluded + aggregatedOrdersB.sumOrderTotalTaxIncluded
    };
};
/**
 * Compute the evolution of the selected aggregated orders with the given reference
 *
 * @param aggregatedOrdersA aggregated order to use as the base selection
 * @param aggregatedOrdersB aggregated order to use as reference
 * @returns the aggregated order evolution
 */ const computeAggregatedOrdersEvolution = function() {
    let selected = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initAggregatedOrder(), reference = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : initAggregatedOrder();
    return {
        sumOrderAverageSpentTaxExcluded: computeEvolution(computeAverageSpent(selected.sumOrderTotalTaxExcluded, selected.sumOrderCustomersCount), computeAverageSpent(reference.sumOrderTotalTaxExcluded, reference.sumOrderCustomersCount)),
        sumOrderAverageSpentTaxIncluded: computeEvolution(computeAverageSpent(selected.sumOrderTotalTaxIncluded, selected.sumOrderCustomersCount), computeAverageSpent(reference.sumOrderTotalTaxIncluded, reference.sumOrderCustomersCount)),
        sumOrderCustomersCount: computeEvolution(selected.sumOrderCustomersCount, reference.sumOrderCustomersCount),
        sumOrderDiscountAmount: computeEvolution(selected.sumOrderDiscountAmount, reference.sumOrderDiscountAmount),
        sumOrderTotalCancelled: computeEvolution(selected.sumOrderTotalCancelled, reference.sumOrderTotalCancelled),
        sumOrderTotalDiscount: computeEvolution(selected.sumOrderTotalDiscount, reference.sumOrderTotalDiscount),
        sumOrderTotalTaxAmount: computeEvolution(selected.sumOrderTotalTaxAmount, reference.sumOrderTotalTaxAmount),
        sumOrderTotalTaxExcluded: computeEvolution(selected.sumOrderTotalTaxExcluded, reference.sumOrderTotalTaxExcluded),
        sumOrderTotalTaxIncluded: computeEvolution(selected.sumOrderTotalTaxIncluded, reference.sumOrderTotalTaxIncluded)
    };
};

// EXTERNAL MODULE: ./src/modules/Reports/helpers.ts
var helpers = __webpack_require__(43549);
;// CONCATENATED MODULE: ./src/modules/Orders/reducer.ts

const { reducer , actions  } = (0,helpers/* createReportReducer */.jH)("orders");
const { request: requestOrderInfo , succeeded: succeededOrderInfo , failed: failedOrderInfo ,  } = actions;
/* harmony default export */ var Orders_reducer = (reducer);

// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./src/errors/index.ts + 10 modules
var errors = __webpack_require__(62640);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/Reports/index.ts + 7 modules
var Reports = __webpack_require__(86922);
;// CONCATENATED MODULE: ./src/modules/Orders/types/api.ts
var ApiOrdersField;
(function(ApiOrdersField) {
    ApiOrdersField["OpeningStaffName"] = "opening_staff_name";
    ApiOrdersField["ClosingStaffName"] = "closing_staff_name";
    ApiOrdersField["OrderClosedAt"] = "order_closed_at";
    ApiOrdersField["OrderCreatedAt"] = "order_created_at";
    ApiOrdersField["OrderCustomersCount"] = "order_customers_count";
    ApiOrdersField["OrderDiscountAmount"] = "order_discount_amount";
    ApiOrdersField["OrderName"] = "order_name";
    ApiOrdersField["OrderOpenedAt"] = "order_opened_at";
    ApiOrdersField["OrderStatus"] = "order_status";
    ApiOrdersField["OrderTotalCancelled"] = "order_total_cancelled";
    ApiOrdersField["OrderTotalDiscount"] = "order_total_discount";
    ApiOrdersField["OrderTotalTaxAmount"] = "order_total_tax_amount";
    ApiOrdersField["OrderTotalTaxExcluded"] = "order_total_tax_excluded";
    ApiOrdersField["OrderTotalTaxIncluded"] = "order_total_tax_included";
    ApiOrdersField["OrderUuid"] = "order_uuid";
    ApiOrdersField["PaymentStatus"] = "payment_status";
    ApiOrdersField["StoreId"] = "store_id";
    ApiOrdersField["SumPayments"] = "sum_payments";
    ApiOrdersField["TableName"] = "table_name";
})(ApiOrdersField || (ApiOrdersField = {}));
var ApiAggregatedOrdersField;
(function(ApiAggregatedOrdersField) {
    ApiAggregatedOrdersField["SumOrderCustomersCount"] = "sum_order_customers_count";
    ApiAggregatedOrdersField["SumOrderTotalTaxIncluded"] = "sum_order_total_tax_included";
    ApiAggregatedOrdersField["SumOrderTotalTaxExcluded"] = "sum_order_total_tax_excluded";
    ApiAggregatedOrdersField["SumOrderTotalTaxAmount"] = "sum_order_total_tax_amount";
    ApiAggregatedOrdersField["SumOrderTotalCancelled"] = "sum_order_total_cancelled";
    ApiAggregatedOrdersField["SumOrderDiscountAmount"] = "sum_order_discount_amount";
    ApiAggregatedOrdersField["SumOrderTotalDiscount"] = "sum_order_total_discount";
    ApiAggregatedOrdersField["OrderStatus"] = "order_status";
    ApiAggregatedOrdersField["Hour"] = "hour";
    ApiAggregatedOrdersField["Day"] = "day";
    ApiAggregatedOrdersField["Week"] = "week";
    ApiAggregatedOrdersField["SevenDays"] = "sevendays";
    ApiAggregatedOrdersField["Month"] = "month";
    ApiAggregatedOrdersField["Year"] = "year";
})(ApiAggregatedOrdersField || (ApiAggregatedOrdersField = {}));
var ApiOrdersAggregate;
(function(ApiOrdersAggregate) {
    ApiOrdersAggregate["Status"] = "status";
    ApiOrdersAggregate["Hour"] = "hour";
    ApiOrdersAggregate["Day"] = "day";
    ApiOrdersAggregate["Week"] = "week";
    ApiOrdersAggregate["SevenDays"] = "sevenDays";
    ApiOrdersAggregate["Month"] = "month";
    ApiOrdersAggregate["Year"] = "year";
})(ApiOrdersAggregate || (ApiOrdersAggregate = {}));

;// CONCATENATED MODULE: ./src/modules/Orders/types/types.ts
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["None"] = "";
    OrderStatus["Cancelled"] = "CANCEL";
    OrderStatus["Closed"] = "CLOSE";
    OrderStatus["InProgress"] = "IN_PROGRESS";
    OrderStatus["Transferred"] = "TRANSFER";
})(OrderStatus || (OrderStatus = {}));

;// CONCATENATED MODULE: ./src/modules/Orders/types/index.ts



;// CONCATENATED MODULE: ./src/modules/Orders/services.ts





const mapApiDataToOrderInfo = (apiData)=>({
        orderCustomersCount: Number(apiData[ApiOrdersField.OrderCustomersCount]),
        orderTotalTaxIncluded: Number(apiData[ApiOrdersField.OrderTotalTaxIncluded]),
        orderTotalTaxExcluded: Number(apiData[ApiOrdersField.OrderTotalTaxExcluded]),
        orderTotalTaxAmount: Number(apiData[ApiOrdersField.OrderTotalTaxAmount]),
        orderTotalCancelled: Number(apiData[ApiOrdersField.OrderTotalCancelled]),
        orderDiscountAmount: Number(apiData[ApiOrdersField.OrderDiscountAmount]),
        orderTotalDiscount: Number(apiData[ApiOrdersField.OrderTotalDiscount]),
        orderCreatedAt: String(apiData[ApiOrdersField.OrderCreatedAt]),
        orderStatus: apiData[ApiOrdersField.OrderStatus],
        tableName: String(apiData[ApiOrdersField.TableName]),
        openingStaffName: String(apiData[ApiOrdersField.OpeningStaffName]),
        closingStaffName: String(apiData[ApiOrdersField.ClosingStaffName] || ""),
        storeId: String(apiData[ApiOrdersField.StoreId]),
        orderName: String(apiData[ApiOrdersField.OrderName]),
        orderClosedAt: String(apiData[ApiOrdersField.OrderClosedAt]),
        orderUuid: String(apiData[ApiOrdersField.OrderUuid]),
        orderOpenedAt: String(apiData[ApiOrdersField.OrderOpenedAt]),
        sumPayments: Number(apiData[ApiOrdersField.SumPayments])
    });
const mapApiDataToAggregatedOrderInfo = (apiData, _storeId, param)=>{
    let { period  } = param;
    return {
        sumOrderAverageSpentTaxIncluded: computeAverageSpent(Number(apiData[ApiAggregatedOrdersField.SumOrderTotalTaxIncluded]), Number(apiData[ApiAggregatedOrdersField.SumOrderCustomersCount])),
        sumOrderAverageSpentTaxExcluded: computeAverageSpent(Number(apiData[ApiAggregatedOrdersField.SumOrderTotalTaxExcluded]), Number(apiData[ApiAggregatedOrdersField.SumOrderCustomersCount])),
        sumOrderCustomersCount: Number(apiData[ApiAggregatedOrdersField.SumOrderCustomersCount]),
        sumOrderTotalTaxIncluded: Number(apiData[ApiAggregatedOrdersField.SumOrderTotalTaxIncluded]),
        sumOrderTotalTaxExcluded: Number(apiData[ApiAggregatedOrdersField.SumOrderTotalTaxExcluded]),
        sumOrderTotalTaxAmount: Number(apiData[ApiAggregatedOrdersField.SumOrderTotalTaxAmount]),
        sumOrderTotalCancelled: Number(apiData[ApiAggregatedOrdersField.SumOrderTotalCancelled]),
        sumOrderDiscountAmount: Number(apiData[ApiAggregatedOrdersField.SumOrderDiscountAmount]),
        sumOrderTotalDiscount: Number(apiData[ApiAggregatedOrdersField.SumOrderTotalDiscount]),
        orderStatus: apiData[ApiAggregatedOrdersField.OrderStatus],
        hour: (0,Reports/* tryTransformToDate */.eu)(apiData[ApiAggregatedOrdersField.Hour]),
        day: (0,Reports/* tryTransformToDate */.eu)(apiData[ApiAggregatedOrdersField.Day]),
        week: (0,Reports/* tryTransformToDate */.eu)(apiData[ApiAggregatedOrdersField.Week]),
        sevenDays: typeof apiData[ApiAggregatedOrdersField.SevenDays] === "number" ? period.interval.start.plus({
            week: apiData[ApiAggregatedOrdersField.SevenDays]
        }).startOf("day") : undefined,
        month: (0,Reports/* tryTransformToDate */.eu)(apiData[ApiAggregatedOrdersField.Month]),
        year: (0,Reports/* tryTransformToDate */.eu)(apiData[ApiAggregatedOrdersField.Year])
    };
};
const getOrdersPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        resource: Reports/* ReportResource.Orders */.Hh.Orders
    }), mapApiDataToOrderInfo);
const getAggregatedOrdersPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        resource: Reports/* ReportResource.Orders */.Hh.Orders
    }), mapApiDataToAggregatedOrderInfo);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/modules/Orders/utils.ts




/**
 * A function to set totals to 0 when an order has the CANCEL status.
 * @param perStoreOrders
 */ const overrideCanceledOrders = (perStoreOrders)=>(0,lodash.mapValues)(perStoreOrders, (orders)=>orders.map((order)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, order), {
                orderTotalTaxExcluded: order.orderStatus !== OrderStatus.Cancelled ? order.orderTotalTaxExcluded : 0,
                orderTotalTaxIncluded: order.orderStatus !== OrderStatus.Cancelled ? order.orderTotalTaxIncluded : 0
            })));

;// CONCATENATED MODULE: ./src/modules/Orders/sagas.ts





function* getOrdersSaga(param) {
    let { payload: query  } = param;
    try {
        const data = yield (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getOrdersPerStoreAsync, query);
        const result = overrideCanceledOrders(data);
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(succeededOrderInfo(result));
    } catch (e) {
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failedOrderInfo({
            storeIds: query.storeIds,
            error: (0,errors/* createError */.Tr)(e)
        }));
    }
}
function* ordersWatcher() {
    yield (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(requestOrderInfo.type, getOrdersSaga);
};

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/http-status-codes/build/es/status-codes.js
var status_codes = __webpack_require__(56647);
// EXTERNAL MODULE: ./src/modules/Stores/index.ts + 2 modules
var Stores = __webpack_require__(74919);
// EXTERNAL MODULE: ./src/types/index.ts + 1 modules
var types = __webpack_require__(87202);
;// CONCATENATED MODULE: ./src/modules/Orders/selectors.ts








const selectAllOrdersPerStore = (param)=>{
    let { orders  } = param;
    return orders;
};
const selectOrdersError = (0,es/* createSelector */.P1)(selectAllOrdersPerStore, (ordersPerStore)=>{
    var ref;
    return (ref = (0,lodash.find)(ordersPerStore, (orders)=>orders.error !== undefined)) === null || ref === void 0 ? void 0 : ref.error;
});
const selectHasUnprocessableEntityError = (0,es/* createSelector */.P1)(selectOrdersError, (orderErrors)=>orderErrors instanceof errors/* ApiError */.MS && orderErrors.code === status_codes/* StatusCodes.UNPROCESSABLE_ENTITY */.W.UNPROCESSABLE_ENTITY);
const selectAreOrdersLoaded = (0,es/* createSelector */.P1)(selectAllOrdersPerStore, (ordersPerStore)=>(0,lodash.isEmpty)(ordersPerStore) || (0,lodash.every)(ordersPerStore, (orders)=>orders.status === types/* Status.SUCCEEDED */.q.SUCCEEDED || orders.status === types/* Status.FAILED */.q.FAILED));
const selectAllOrders = (0,es/* createSelector */.P1)(selectAllOrdersPerStore, Stores/* selectStores */.EJ, (ordersPerStore, stores)=>(0,lodash.reduce)(ordersPerStore, (orders, param, storeId)=>{
        let { entities  } = param;
        const store = stores.find((param)=>{
            let { id  } = param;
            return id === Number(storeId);
        });
        return !store || !entities ? orders : [
            ...orders,
            ...entities.map((orderInfo)=>(0,_object_spread/* default */.Z)({
                    store
                }, orderInfo))
        ];
    }, []));
const selectClosedAndCanceledOrders = (0,es/* createSelector */.P1)(selectAllOrders, (orders)=>orders.filter((param)=>{
        let { orderStatus  } = param;
        return [
            OrderStatus.Closed,
            OrderStatus.Cancelled
        ].includes(orderStatus);
    }));

// EXTERNAL MODULE: ./src/modules/Orders/useLegacyOrdersAggregated.ts + 1 modules
var useLegacyOrdersAggregated = __webpack_require__(86060);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/modules/Entities/actions.js
var Entities_actions = __webpack_require__(5135);
;// CONCATENATED MODULE: ./src/modules/Orders/useLegacyOrdersExport.ts



function useLegacyOrdersExport() {
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    const requestReportSynthesis = (0,react.useCallback)(()=>{
        dispatch((0,Entities_actions/* reportSynthesisRequested */.Y_)());
    }, [
        dispatch
    ]);
    return {
        error: undefined,
        isLoading: false,
        requestReportSynthesis
    };
}
/* harmony default export */ var Orders_useLegacyOrdersExport = (useLegacyOrdersExport);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 5 modules
var useQuery = __webpack_require__(81503);
// EXTERNAL MODULE: ./src/modules/Entities/RevenuesAggregated/actions.js
var RevenuesAggregated_actions = __webpack_require__(68174);
// EXTERNAL MODULE: ./src/modules/Entities/CustomersCountsAggregated/actions.js
var CustomersCountsAggregated_actions = __webpack_require__(87652);
// EXTERNAL MODULE: ./src/modules/Entities/AverageSpents/selectors.js
var selectors = __webpack_require__(39771);
// EXTERNAL MODULE: ./src/modules/Preferences/selectors/index.ts + 10 modules
var Preferences_selectors = __webpack_require__(95861);
// EXTERNAL MODULE: ./src/modules/Entities/helpers.js
var Entities_helpers = __webpack_require__(37338);
;// CONCATENATED MODULE: ./src/modules/Entities/CustomersCountsAggregated/selectors.js


/**
 *  Customers counts aggregated memoized Selectors
 */ 


/**
 * Get data about aggregated customers counts retrieved from api
 *
 * @return {Object}
 */ const getCustomersCountsAggregatedEntities = (param)=>{
    let { entities  } = param;
    return entities.customersCountsAggregated.entities;
};
/**
 * Get status about aggregated customers counts request
 * `none`, `loading`, `loaded` or `failed`
 *
 * @return {string}
 */ const getCustomersCountsAggregatedStatus = (param)=>{
    let { entities  } = param;
    return entities.customersCountsAggregated.status;
};
/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getCustomersCountsAggregatedError = (param)=>{
    let { entities  } = param;
    return entities.customersCountsAggregated.error;
};
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areCustomersCountsAggregatedLoading = (0,es/* createSelector */.P1)([
    getCustomersCountsAggregatedStatus
], (status)=>status === "loading");
/**
 * Get customers counts data of selected stores
 *
 * @return {Array}
 */ const getDataOfSelectedStores = (0,es/* createSelector */.P1)([
    getCustomersCountsAggregatedEntities,
    Preferences_selectors/* getSelectedStoresIds */.F
], (entities, storeIds)=>entities && storeIds ? Object.keys(entities).filter((id)=>storeIds.includes(parseInt(id, 10))).map((id)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entities[id]), {
            id
        })) : []);
/**
 * Get customers counts data of selected stores and selected period
 * If there is no data, the api does not return the `selected` key, so we check the existence of the key
 *
 * @return {Array}
 */ const getSelectedDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    getDataOfSelectedStores
], (data)=>data.map((param)=>{
        let { id , selected  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
            value: {
                customersCount: selected && selected.value.customersCount ? selected.value.customersCount : 0
            }
        }), {
            id
        });
    }));
/**
 * Provides customers counts on selected stores and selected period
 *
 * @return {number}
 */ const getSelectedCustomersCountsAggregated = (0,es/* createSelector */.P1)([
    getSelectedDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.customersCount;
    }, 0));
/**
 * Get customers counts data of selected stores and reference period
 * If there is no data, the api does not return the `reference` key, so we check the existence of the key
 *
 * @return {Array}
 */ const getReferenceDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    getDataOfSelectedStores
], (data)=>data.map((param)=>{
        let { id , reference  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
            value: {
                customersCount: reference && reference.value.customersCount ? reference.value.customersCount : 0
            }
        }), {
            id
        });
    }));
/**
 * Provides customers counts on selected stores and reference period
 *
 * @return {number}
 */ const getReferenceCustomersCountsAggregated = (0,es/* createSelector */.P1)([
    getReferenceDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.customersCount;
    }, 0));
/**
 * Get evolution of customers counts from datas of reference period and selected period
 * Ratio between reference and selected datas
 *
 * @return {number}
 */ const getEvolutionCustomersCountsAggregated = (0,es/* createSelector */.P1)([
    getReferenceCustomersCountsAggregated,
    getSelectedCustomersCountsAggregated
], (reference, selected)=>(0,Entities_helpers/* getEvolution */.fn)(selected, reference));

// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/Entities/RevenuesAggregated/selectors.js


/**
 * Aggregated revenues memoized selectors
 */ 


/**
 * Get data about aggregated revenues retrieved from api
 *
 * @return {Object}
 */ const getRevenuesAggregatedEntities = (param)=>{
    let { entities  } = param;
    return entities.revenuesAggregated.entities;
};
/**
 * Get status about aggregated revenues request
 * `none`, `loading`, `loaded` or `failed`
 *
 * @return {string}
 */ const getRevenuesAggregatedStatus = (param)=>{
    let { entities  } = param;
    return entities.revenuesAggregated.status;
};
/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getRevenuesAggregatedError = (param)=>{
    let { entities  } = param;
    return entities.revenuesAggregated.error;
};
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areRevenuesAggregatedLoading = (0,es/* createSelector */.P1)([
    getRevenuesAggregatedStatus
], (status)=>status === "loading");
/**
 * Get revenues of selected stores
 *
 * @return {Array}
 */ const selectors_getDataOfSelectedStores = (0,es/* createSelector */.P1)([
    getRevenuesAggregatedEntities,
    Preferences/* getSelectedStoresIds */.F
], (entities, storeIds)=>entities && storeIds ? Object.keys(entities).filter((id)=>storeIds.includes(parseInt(id, 10))).map((id)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entities[id]), {
            id
        })) : []);
/**
 * Get revenues data of selected stores and selected period
 * If there is no data, the api does not return the `selected` key, so we check the existence of the key
 *
 * @return {Array}
 */ const selectors_getSelectedDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    selectors_getDataOfSelectedStores
], (data)=>data.map((param)=>{
        let { id , selected  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
            value: {
                tax_excluded: selected && selected.value.tax_excluded ? selected.value.tax_excluded : 0,
                tax_included: selected && selected.value.tax_included ? selected.value.tax_included : 0
            }
        }), {
            id
        });
    }));
/**
 * Calculates selected revenues without tax on selected stores
 *
 * @return {number}
 */ const getSelectedDataTaxExcluded = (0,es/* createSelector */.P1)([
    selectors_getSelectedDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.tax_excluded;
    }, 0));
/**
 * Calculates selected revenues with tax on selected stores
 *
 * @return {number}
 */ const getSelectedDataTaxIncluded = (0,es/* createSelector */.P1)([
    selectors_getSelectedDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.tax_included;
    }, 0));
/**
 * Provides revenues on selected stores and selected period
 *
 * @return {number}
 */ const getSelectedRevenuesAggregated = (0,es/* createSelector */.P1)([
    Preferences/* selectIsTaxIncluded */.t3,
    getSelectedDataTaxIncluded,
    getSelectedDataTaxExcluded
], (isTaxIncl, dataTaxIncluded, dataTaxExcluded)=>isTaxIncl ? dataTaxIncluded : dataTaxExcluded);
/**
 * Get revenues data of selected stores and reference period
 * If there is no data, the api does not return the `reference` key, so we check the existence of the key
 *
 * @return {Array}
 */ const selectors_getReferenceDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    selectors_getDataOfSelectedStores
], (data)=>data.map((param)=>{
        let { id , reference  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
            value: {
                tax_excluded: reference && reference.value.tax_excluded ? reference.value.tax_excluded : 0,
                tax_included: reference && reference.value.tax_included ? reference.value.tax_included : 0
            }
        }), {
            id
        });
    }));
/**
 * Calculates reference revenues without tax on selected stores
 *
 * @return {number}
 */ const getReferenceDataTaxExcluded = (0,es/* createSelector */.P1)([
    selectors_getReferenceDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.tax_excluded;
    }, 0));
/**
 * Calculates reference revenues with tax on selected stores
 *
 * @return {number}
 */ const getReferenceDataTaxIncluded = (0,es/* createSelector */.P1)([
    selectors_getReferenceDataKpiOfSelectedStores
], (data)=>data.reduce((acc, param)=>{
        let { value  } = param;
        return acc + value.tax_included;
    }, 0));
/**
 * Provides revenues on selected stores and reference period
 *
 * @return {number}
 */ const getReferenceRevenuesAggregated = (0,es/* createSelector */.P1)([
    Preferences/* selectIsTaxIncluded */.t3,
    getReferenceDataTaxExcluded,
    getReferenceDataTaxIncluded
], (tax, dataTaxExcluded, dataTaxIncluded)=>!tax ? dataTaxExcluded : dataTaxIncluded);
/**
 * Get evolution of revenues from datas of reference period and selected period
 * Ratio between reference and selected datas
 *
 * @return {number}
 */ const getEvolutionRevenuesAggregated = (0,es/* createSelector */.P1)(// pick of a piece of state
[
    getReferenceRevenuesAggregated,
    getSelectedRevenuesAggregated
], // function that has our select logic
(reference, selected)=>(0,Entities_helpers/* getEvolution */.fn)(selected, reference));

;// CONCATENATED MODULE: ./src/modules/Entities/AverageSpentsAggregated/selectors.js


/**
 * Average spents aggregated memoized Selectors
 * All datas are computed from customers counts and revenues fetched data
 *
 */ 



/**
 * If last attempt at fetching data resulted in an error, returns the error value
 *
 * @return {string}
 */ const getAverageSpentsAggregatedError = (0,es/* createSelector */.P1)([
    getCustomersCountsAggregatedError,
    getRevenuesAggregatedError
], (customersCountsError, revenuesError)=>customersCountsError || revenuesError);
/**
 * If data is being fetched
 *
 * @return {boolean}
 */ const areAverageSpentsAggregatedLoading = (0,es/* createSelector */.P1)([
    areCustomersCountsAggregatedLoading,
    areRevenuesAggregatedLoading
], (customersCountsLoading, revenuesLoading)=>customersCountsLoading || revenuesLoading);
/**
 * Get aggregated average spents data of selected stores and selected period
 * If there is no data, the api does not return the `selected` key, so we check the existence of the key
 *
 * @return {Array}
 */ const AverageSpentsAggregated_selectors_getSelectedDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    getSelectedDataKpiOfSelectedStores,
    selectors_getSelectedDataKpiOfSelectedStores
], (customersCounts, revenues)=>customersCounts.length && revenues.length ? customersCounts.map((param, i)=>{
        let { id , value  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value.customersCount ? {
            value: {
                tax_excluded: revenues[i].value.tax_excluded / value.customersCount,
                tax_included: revenues[i].value.tax_included / value.customersCount
            }
        } : {
            value: {
                tax_excluded: 0,
                tax_included: 0
            }
        }), {
            id
        });
    }) : []);
/**
 * Provides aggregated average spents on selected stores and selected period
 *
 * @return {number}
 */ const getSelectedAverageSpentsAggregated = (0,es/* createSelector */.P1)([
    getSelectedCustomersCountsAggregated,
    getSelectedRevenuesAggregated
], (customersCounts, revenues)=>customersCounts ? revenues / customersCounts : revenues);
/**
 * Get aggregated average spents data of selected stores and reference period
 * If there is no data, the api does not return the `reference` key, so we check the existence of the key
 *
 * @return {Array}
 */ const AverageSpentsAggregated_selectors_getReferenceDataKpiOfSelectedStores = (0,es/* createSelector */.P1)([
    getReferenceDataKpiOfSelectedStores,
    selectors_getReferenceDataKpiOfSelectedStores
], (customersCounts, revenues)=>customersCounts.length && revenues.length ? customersCounts.map((param, i)=>{
        let { id , value  } = param;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value.customersCount ? {
            value: {
                tax_excluded: revenues[i].value.tax_excluded / value.customersCount,
                tax_included: revenues[i].value.tax_included / value.customersCount
            }
        } : {
            value: {
                tax_excluded: 0,
                tax_included: 0
            }
        }), {
            id
        });
    }) : []);
/**
 * Provides average spent on selected stores and reference period
 *
 * @return {number}
 */ const getReferenceAverageSpentsAggregated = (0,es/* createSelector */.P1)([
    getReferenceCustomersCountsAggregated,
    getReferenceRevenuesAggregated
], (customersCounts, revenues)=>customersCounts ? revenues / customersCounts : 0);
/**
 * Get evolution of average spents from datas of reference period and selected period
 * Ratio between reference and selected datas
 *
 * @return {number}
 */ const getEvolutionAverageSpentsAggregated = (0,es/* createSelector */.P1)([
    getReferenceAverageSpentsAggregated,
    getSelectedAverageSpentsAggregated
], (reference, selected)=>(0,Entities_helpers/* getEvolution */.fn)(selected, reference));

// EXTERNAL MODULE: ./src/modules/Stores/selectors.ts
var Stores_selectors = __webpack_require__(73044);
;// CONCATENATED MODULE: ./src/modules/Entities/selectors.js
/**
 * Entities Selectors
 * Creating Memoized Selectors
 */ 






/**
 * Get all stores KPIs used to hydrate table below the graph on the Dashboard page.
 * Check PerStoreTable component to see use case of that method.
 *
 * @return {Object[]} array of { name, customersCount: {evolution, selected}, averageSpent: {evolution, selected}, taxExcluded: {evolution, selected}, taxIncluded: {evolution, selected}}
 */ const getKpisPerStore = (0,es/* createSelector */.P1)([
    AverageSpentsAggregated_selectors_getSelectedDataKpiOfSelectedStores,
    AverageSpentsAggregated_selectors_getReferenceDataKpiOfSelectedStores,
    getSelectedDataKpiOfSelectedStores,
    getReferenceDataKpiOfSelectedStores,
    selectors_getSelectedDataKpiOfSelectedStores,
    selectors_getReferenceDataKpiOfSelectedStores,
    Stores_selectors/* selectStores */.EJ,
    Preferences_selectors/* getSelectedStoresIds */.F,
    Preferences_selectors/* selectIsTaxIncluded */.t3, 
], (selectedAverageSpents, referenceAverageSpents, selectedCustomersCounts, referenceCustomersCounts, selectedRevenues, referenceRevenues, stores, storeIds, isTaxIncl)=>{
    if (selectedAverageSpents.length && referenceAverageSpents.length && referenceCustomersCounts.length && selectedCustomersCounts.length && referenceRevenues.length && selectedRevenues.length && stores.length && storeIds.length) {
        const taxKey = isTaxIncl ? "tax_included" : "tax_excluded";
        return storeIds.map((storeId)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { name  } = stores.find((param)=>{
                let { id  } = param;
                return id === storeId;
            });
            var _customersCount;
            const selectedCustomersCount = (_customersCount = (ref = selectedCustomersCounts.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref === void 0 ? void 0 : ref.value.customersCount) !== null && _customersCount !== void 0 ? _customersCount : 0;
            var _customersCount1;
            const referenceCustomersCount = (_customersCount1 = (ref1 = referenceCustomersCounts.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref1 === void 0 ? void 0 : ref1.value.customersCount) !== null && _customersCount1 !== void 0 ? _customersCount1 : 0;
            var _taxKey;
            const selectedAverageSpent = (_taxKey = (ref2 = selectedAverageSpents.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref2 === void 0 ? void 0 : ref2.value[taxKey]) !== null && _taxKey !== void 0 ? _taxKey : 0;
            var _taxKey1;
            const referenceAverageSpent = (_taxKey1 = (ref3 = referenceAverageSpents.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref3 === void 0 ? void 0 : ref3.value[taxKey]) !== null && _taxKey1 !== void 0 ? _taxKey1 : 0;
            var ref6;
            const selectedRevenue = (ref6 = (ref4 = selectedRevenues.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref6 !== void 0 ? ref6 : 0;
            var ref7;
            const referenceRevenue = (ref7 = (ref5 = referenceRevenues.find((param)=>{
                let { id  } = param;
                return parseInt(id, 10) === storeId;
            })) === null || ref5 === void 0 ? void 0 : ref5.value) !== null && ref7 !== void 0 ? ref7 : 0;
            return {
                name,
                customersCount: {
                    selected: selectedCustomersCount,
                    evolution: (0,Entities_helpers/* getEvolution */.fn)(selectedCustomersCount, referenceCustomersCount)
                },
                averageSpent: {
                    selected: selectedAverageSpent,
                    evolution: (0,Entities_helpers/* getEvolution */.fn)(selectedAverageSpent, referenceAverageSpent)
                },
                taxExcluded: {
                    selected: selectedRevenue.tax_excluded,
                    evolution: (0,Entities_helpers/* getEvolution */.fn)(selectedRevenue.tax_excluded, referenceRevenue.tax_excluded)
                },
                taxIncluded: {
                    selected: selectedRevenue.tax_included,
                    evolution: (0,Entities_helpers/* getEvolution */.fn)(selectedRevenue.tax_included, referenceRevenue.tax_included)
                }
            };
        });
    }
    return [];
});

;// CONCATENATED MODULE: ./src/modules/Orders/useLegacyOrdersKpi.ts








function useLegacyOrdersKpi(param) {
    let { period , referenceCode , timeSlot , trainingMode , canRequestReports  } = param;
    const periodAsString = period.serialize();
    const timeSlotAsString = timeSlot.serialize();
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    (0,useQuery/* useQuery */.a)([
        "legacyRequestOrdersKpi",
        {
            canRequestReports,
            referenceCode,
            trainingMode,
            periodAsString,
            timeSlotAsString
        }, 
    ], ()=>{
        if (canRequestReports) {
            dispatch((0,RevenuesAggregated_actions/* revenuesAggregatedRequested */.gG)());
            dispatch((0,CustomersCountsAggregated_actions/* customersCountsAggregatedRequested */.q9)());
        }
        return true;
    }, // override default value set in queryConfig
    // allways execute the query (but only once per page)
    // as the result is in the redux store
    // the api call will update the store state
    {
        staleTime: 0
    });
    const isLoading = (0,react_redux_es/* useSelector */.v9)(selectors/* areAverageSpentsLoading */.kk);
    const averageSpentsKpi = {
        error: (0,react_redux_es/* useSelector */.v9)(getAverageSpentsAggregatedError),
        evolution: (0,react_redux_es/* useSelector */.v9)(getEvolutionAverageSpentsAggregated),
        isLoading: (0,react_redux_es/* useSelector */.v9)(areAverageSpentsAggregatedLoading),
        reference: (0,react_redux_es/* useSelector */.v9)(getReferenceAverageSpentsAggregated),
        selected: (0,react_redux_es/* useSelector */.v9)(getSelectedAverageSpentsAggregated)
    };
    const customersCountsKpi = {
        error: (0,react_redux_es/* useSelector */.v9)(getCustomersCountsAggregatedError),
        evolution: (0,react_redux_es/* useSelector */.v9)(getEvolutionCustomersCountsAggregated),
        isLoading: (0,react_redux_es/* useSelector */.v9)(areCustomersCountsAggregatedLoading),
        reference: (0,react_redux_es/* useSelector */.v9)(getReferenceCustomersCountsAggregated),
        selected: (0,react_redux_es/* useSelector */.v9)(getSelectedCustomersCountsAggregated)
    };
    const revenuesKpi = {
        error: (0,react_redux_es/* useSelector */.v9)(getRevenuesAggregatedError),
        evolution: (0,react_redux_es/* useSelector */.v9)(getEvolutionRevenuesAggregated),
        isLoading: (0,react_redux_es/* useSelector */.v9)(areRevenuesAggregatedLoading),
        reference: (0,react_redux_es/* useSelector */.v9)(getReferenceRevenuesAggregated),
        selected: (0,react_redux_es/* useSelector */.v9)(getSelectedRevenuesAggregated)
    };
    const kpisPerStore = (0,react_redux_es/* useSelector */.v9)(getKpisPerStore);
    return {
        isLoading,
        averageSpentsKpi,
        customersCountsKpi,
        revenuesKpi,
        kpisPerStore
    };
}
/* harmony default export */ var Orders_useLegacyOrdersKpi = (useLegacyOrdersKpi);

;// CONCATENATED MODULE: ./src/modules/Orders/useOrdersQuery.ts





function useOrdersQuery(param) {
    let { storeIds , period , timeSlot , isTrainingMode =false , referenceCode , timeAggregate , canRequestReports =true  } = param;
    const aggregates = [
        ApiOrdersAggregate.Status
    ];
    const selectedPeriod = period.getCappedPeriod();
    if (timeAggregate) {
        aggregates.push(timeAggregate);
    }
    const query = {
        aggregates,
        filters: [
            {
                filterName: ApiOrdersAggregate.Status,
                value: OrderStatus.Closed
            }
        ],
        period: selectedPeriod,
        storeIds,
        timeSlot,
        trainingMode: isTrainingMode
    };
    return (0,useQuery/* useQuery */.a)([
        "orders",
        "aggregates",
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            period: selectedPeriod.serialize(),
            timeSlot: timeSlot.serialize()
        }), 
    ], ()=>{
        const aggregatedOrdersPromises = [
            getAggregatedOrdersPerStoreAsync(query)
        ];
        const referencePeriod = selectedPeriod.getReferencePeriod(referenceCode);
        if (referencePeriod) {
            aggregatedOrdersPromises.push(getAggregatedOrdersPerStoreAsync((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                period: referencePeriod
            })));
        }
        return Promise.all(aggregatedOrdersPromises);
    }, {
        enabled: canRequestReports && storeIds.length > 0
    });
}
/* harmony default export */ var Orders_useOrdersQuery = (useOrdersQuery);

;// CONCATENATED MODULE: ./src/modules/Orders/useOrdersAggregated.ts

function useOrdersAggregated(param) {
    let { storeIds , timeAggregate , period , timeSlot , referenceCode , isTrainingMode =false , canRequestReports =true  } = param;
    const { data =[] , error , isLoading , isError  } = Orders_useOrdersQuery({
        storeIds,
        period,
        timeSlot,
        isTrainingMode,
        referenceCode,
        timeAggregate,
        canRequestReports
    });
    const [selected = {}, reference = undefined] = data;
    return {
        error: error !== null && error !== void 0 ? error : undefined,
        isLoading,
        isError,
        selected,
        reference
    };
}
/* harmony default export */ var Orders_useOrdersAggregated = (useOrdersAggregated);

;// CONCATENATED MODULE: ./src/modules/Orders/useOrdersKpi.ts



function useOrdersKpi(param) {
    let { storeIds , period , timeSlot , referenceCode , isTrainingMode =false , canRequestReports =true  } = param;
    const { data =[] , error , isLoading , isError ,  } = Orders_useOrdersQuery({
        storeIds,
        period,
        timeSlot,
        isTrainingMode,
        referenceCode,
        canRequestReports
    });
    const selectedOrdersKpis = (0,lodash.mapValues)(data[0] || {}, (param)=>{
        let [aggOrders] = param;
        return aggOrders;
    });
    const referenceOrdersKpis = (0,lodash.mapValues)(data[1] || {}, (param)=>{
        let [aggOrders] = param;
        return aggOrders;
    });
    const kpisPerStore = {};
    let selectedKpis = initAggregatedOrder();
    let referenceKpis = initAggregatedOrder();
    storeIds.forEach((storeId)=>{
        selectedKpis = sumAggregatedOrders(selectedKpis, selectedOrdersKpis[storeId]);
        referenceKpis = sumAggregatedOrders(referenceKpis, referenceOrdersKpis[storeId]);
        kpisPerStore[storeId] = {
            selected: selectedOrdersKpis[storeId] || initAggregatedOrder(),
            reference: referenceOrdersKpis[storeId],
            evolution: computeAggregatedOrdersEvolution(selectedOrdersKpis[storeId], referenceOrdersKpis[storeId])
        };
    }, {});
    const evolutionKpis = computeAggregatedOrdersEvolution(selectedKpis, referenceKpis);
    return {
        isLoading,
        isError,
        error: error !== null && error !== void 0 ? error : undefined,
        selected: selectedKpis,
        reference: !(0,lodash.isEmpty)(referenceOrdersKpis) ? referenceKpis : undefined,
        evolution: evolutionKpis,
        kpisPerStore
    };
}
/* harmony default export */ var Orders_useOrdersKpi = (useOrdersKpi);

;// CONCATENATED MODULE: ./src/modules/Orders/index.ts












/***/ }),

/***/ 86060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Orders_useLegacyOrdersAggregated; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var es = __webpack_require__(92145);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 5 modules
var useQuery = __webpack_require__(81503);
// EXTERNAL MODULE: ./src/modules/Entities/actions.js
var actions = __webpack_require__(5135);
// EXTERNAL MODULE: ./src/modules/Entities/AverageSpents/selectors.js
var selectors = __webpack_require__(39771);
// EXTERNAL MODULE: ./src/modules/Entities/CustomersCounts/selectors.js
var CustomersCounts_selectors = __webpack_require__(95321);
// EXTERNAL MODULE: ./src/modules/Entities/Revenues/selectors.js
var Revenues_selectors = __webpack_require__(14164);
// EXTERNAL MODULE: ./node_modules/@tiller/report-sdk/dist/bundle.es.js
var bundle_es = __webpack_require__(88255);
// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/Orders/constants.ts


const tabToChartKPIMapping = {
    [Preferences/* KPITab.Revenue */.lo.Revenue]: bundle_es/* Resource.Revenue */._z.Revenue,
    [Preferences/* KPITab.CustomersCount */.lo.CustomersCount]: bundle_es/* Resource.CustomersCount */._z.CustomersCount,
    [Preferences/* KPITab.AverageSpent */.lo.AverageSpent]: bundle_es/* Resource.AverageSpent */._z.AverageSpent
};

;// CONCATENATED MODULE: ./src/modules/Orders/useLegacyOrdersAggregated.ts







function useLegacyOrdersAggregated(param) {
    let { timeAggregate , period , referenceCode , timeSlot , trainingMode , kpiTab , canRequestReports  } = param;
    const periodAsString = period.serialize();
    const timeSlotAsString = timeSlot.serialize();
    const dispatch = (0,es/* useDispatch */.I0)();
    // Will trigger call(s) to getChart for kpi of current tab
    (0,useQuery/* useQuery */.a)([
        "legacyRequestCharts",
        {
            canRequestReports,
            kpiTab,
            referenceCode,
            trainingMode,
            timeAggregate,
            periodAsString,
            timeSlotAsString
        }, 
    ], ()=>{
        if (canRequestReports) {
            dispatch((0,actions/* chartRequested */.iz)({
                kpi: tabToChartKPIMapping[kpiTab]
            }));
        }
        return true;
    }, // override default value set in queryConfig
    // allways execute the query (but only once per page)
    // as the result is in the redux store
    // the api call will update the store state
    {
        staleTime: 0
    });
    const averageSpentsAggregated = {
        error: (0,es/* useSelector */.v9)(selectors/* getAverageSpentsError */.zn),
        isLoading: (0,es/* useSelector */.v9)(selectors/* areAverageSpentsLoading */.kk),
        data: (0,es/* useSelector */.v9)(selectors/* getAverageSpentsChartData */.uv)
    };
    const customersCountsAggregate = {
        error: (0,es/* useSelector */.v9)(CustomersCounts_selectors/* getCustomersCountsError */.Y9),
        isLoading: (0,es/* useSelector */.v9)(CustomersCounts_selectors/* areCustomersCountsLoading */.AP),
        data: (0,es/* useSelector */.v9)(CustomersCounts_selectors/* getCustomersCountsChartData */.e_)
    };
    const revenuesAggregated = {
        error: (0,es/* useSelector */.v9)(Revenues_selectors/* getRevenuesError */.HI),
        isLoading: (0,es/* useSelector */.v9)(Revenues_selectors/* areRevenuesLoading */.dL),
        data: (0,es/* useSelector */.v9)(Revenues_selectors/* getRevenuesChartData */.En)
    };
    return {
        averageSpentsAggregated,
        customersCountsAggregate,
        revenuesAggregated
    };
}
/* harmony default export */ var Orders_useLegacyOrdersAggregated = (useLegacyOrdersAggregated);


/***/ })

}]);